module.exports = __webpack_public_path__ + "img/case-audit.7e7885cc.jpg";